import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CountryCityService } from '../country-city.service';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-city-list',
  templateUrl: './city-list.component.html',
  styleUrls: ['./city-list.component.scss']
})
export class CityListComponent implements OnInit {
  cityList: any = [];
  selectedCityID = '';
  citiesList: any = [];
  id: number;
  spin: boolean;
  p = 1;
  Imagefile: string;
  uploadForm: FormGroup;

  modalRef: BsModalRef;
  localCity: any = [];
  constructor(
    private formBuilder: FormBuilder,
    private countryService: CountryCityService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: BsModalService
  ) {
    this.id = this.route.snapshot.params['id'];
    // console.log(this.id);
    this.uploadForm = this.formBuilder.group({
      file: ['']
    });
  }

  ngOnInit() {
    this.getAllCities();
    this.getSelectedCityID();
  }
  getCityID(Id, Name) {
    localStorage.setItem('cityId', JSON.stringify(Id));
    localStorage.setItem('cityName', JSON.stringify(Name));
    console.log(localStorage.getItem('cityName'));
    this.selectedCityID = Id;
  }
  getSelectedCityID() {
    this.selectedCityID = localStorage.getItem('cityId');
  }
  getAllCities() {
    this.countryService.getAllCities(this.id).subscribe(Response => {
      this.citiesList = Response;
      if (!this.citiesList[0].Id) {
        this.spin = false;
      } else {
        this.spin = true;
      }
      // console.log("City List",this.citiesList);
    });
  }

  UpdateCity(id) {
    this.router.navigateByUrl('/country/update-city/' + id + '/' + this.id);
  }

  CityNavigation() {
    this.router.navigateByUrl('/country/add-city/' + this.id);
  }

  uploadFileInput(event, cityid) {
   
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.uploadForm.get('file').setValue(file);
      this.Imagefile = file;

      const formData = new FormData();
      formData.append('Files', this.uploadForm.get('file').value);
      formData.append('CityId', cityid.toString());
      this.countryService.uploadImage(formData).subscribe((Data: any) => {
        this.toastr.success('Image Update');
        //  if (!Data.id) {
        //    this.router.navigateByUrl('/country/city-list/' + this.id);
        //  }
        this.getAllCities();
        console.log('City added', Data);

      });
    }
  }

}
